module.exports = __webpack_public_path__ + "35fbb12004574745c4bf0b39569df455.png";